import _ from 'lodash';
import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    layers_legacy: {
        loading: true,
        error: {},
        data: []
    },
    layersmetadata_legacy: {
        loading: true,
        error: {},
        data: []
    },
    layerSettingsDropdown_legacy: [],
    layersAkief_legacy: [],
    overlayevents_legacy: {
        // onMouseMove: (event) => console.log("==> mousemove", event)
    },
    infowindowlayer_legacy: null,
    eventlisternerbind_legacy: false,
    cleanbindedcomponent_legacy: false
};

const toggleLayerSettingsDropdown_legacy = (state, action) => {
    let tempActiveItems = [...state.layerSettingsDropdown_legacy];
    if (tempActiveItems.indexOf(action.key) > -1) {
        tempActiveItems.splice(tempActiveItems.indexOf(action.key));
    } else {
        tempActiveItems.push(action.key);
    }
    return updateObject(state, { layerSettingsDropdown_legacy: tempActiveItems });
};

const initKryLayerlys_legacy = (state, action) => {
    return updateObject(state, {
        layersmetadata: { ...state.layersmetadata_legacy, loading: true }
    });
};

const setLayerlys_legacy = (state, action) => {
    // console.log(action.data);
    return updateObject(state, { layersmetadata_legacy: { ...state.layersmetadata_legacy, data: action.data, loading: false } });
};

const getLayerlysFailed_legacy = (state, action) => {
    return updateObject(state, { layersmetadata_legacy: { ...state.layersmetadata_legacy, error: { error: action.error, easymessage: action.easymessage, status: action.status, message: action.message }, loading: false } });
};

const bindComponent_legacy = (state, action) => {
    return updateObject(state, { cleanbindedcomponent_legacy: false });
};

const kiesLayer_legacy = (state, action) => {
    let cleanbindedcomponent = state.cleanbindedcomponent_legacy;
    let tempActiveItems = [...state.layersAkief_legacy];
    if (tempActiveItems.indexOf(action.key) > -1) {
        tempActiveItems.splice(tempActiveItems.indexOf(action.key));
        cleanbindedcomponent = true;
    } else {
        tempActiveItems.push(action.key);
        const newlayersmetadata = [...state.layersmetadata_legacy.data];
        var mustIBind = false;
        for (var layer of newlayersmetadata) {
            if (layer.id === action.key) {
                for (var tipe of layer.layertipes) {
                    if (tipe.infooverlay) {
                        mustIBind = true;
                    }
                }
            }
        }
    }
    return updateObject(state, { cleanbindedcomponent_legacy: cleanbindedcomponent, eventlisternerbind_legacy: mustIBind, layersAkief_legacy: tempActiveItems });
};

const setLayers_legacy = (state, action) => {
    let newdata = [action.data];
    let historydata = [...state.layers_legacy.data];
    for (var i = 0; i < newdata.length; ++i) {
        var updateItem = newdata[i];
        if (historydata.length > 0) {
            for (var j = 0; j < historydata.length; ++j) {
                if (historydata[j].id === updateItem.id) {
                    historydata[j] = updateItem;
                } else {
                    historydata.push(updateItem);
                }
            }
        } else {
            historydata = [...newdata];
        }
    }
    return updateObject(state, { layers_legacy: { ...state.layers_legacy, data: historydata, loading: false } });
};

const removeLayer_legacy = (state, action) => {
    var finaldata = state.layers_legacy.data.filter((obj) => {
        return obj.id !== action.key;
    });
    return updateObject(state, { layers_legacy: { ...state.layers_legacy, data: finaldata, loading: false } });
}

const changeLayertipe_legacy = (state, action) => {
    let cleanbindedcomponent = state.cleanbindedcomponent_legacy;
    var tempoverlayevents;
    const newlayersmetadata = [...state.layersmetadata_legacy.data];
    var mustIBind = false;
    for (var layer of newlayersmetadata) {
        if (layer.id === action.key) {
            for (var tipe of layer.layertipes) {
                if (tipe.type === action.tipe && tipe.key === action.layerkey) {
                    if (tipe.infooverlay) {
                        mustIBind = true;
                    }
                    tipe.active = true;
                } else {
                    tipe.active = false;
                    cleanbindedcomponent = true;
                }
            }
        }
    }
    return updateObject(state, { layers_legacy: { ...state.layers_legacy, laoding: true }, cleanbindedcomponent_legacy: cleanbindedcomponent, eventlisternerbind_legacy: mustIBind, layersmetadata_legacy: { ...state.layersmetadata_legacy, data: newlayersmetadata }, overlayevents_legacy: { ...state.overlayevents_legacy, ...tempoverlayevents } });
}

const changeLayerFilter_legacy = (state, action) => {
    let newlayersmetadata = _.cloneDeep(state.layersmetadata_legacy.data);
    for (let layer of newlayersmetadata) {
        if (layer.id === action.key) {
            for (let tipe of layer.filters) {
                if (tipe.type === action.tipe) {
                    tipe.filterdata = action.nuwewaarde;
                }
            }
        }
    }
    return updateObject(state, { layersmetadata_legacy: { ...state.layersmetadata_legacy, data: newlayersmetadata } });
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RESET_APP:
            return initialState;
        case actionTypes.LAYERSETTINGS_TOGGLE_LEGACY:
            return toggleLayerSettingsDropdown_legacy(state, action);
        case actionTypes.INIT_LAYERSLYS_LEGACY:
            return initKryLayerlys_legacy(state, action);
        case actionTypes.SET_LAYERSLYS_LEGACY:
            return setLayerlys_legacy(state, action);
        case actionTypes.GET_LAYERSLYS_FAILED_LEGACY:
            return getLayerlysFailed_legacy(state, action);
        case actionTypes.KIES_LAYER_LEGACY:
            return kiesLayer_legacy(state, action);
        case actionTypes.SET_LAYERSAKTIEF_LEGACY:
            return setLayers_legacy(state, action);
        case actionTypes.REMOVE_LAYER_LEGACY:
            return removeLayer_legacy(state, action);
        case actionTypes.CHANGE_LAYERTIPE_LEGACY:
            return changeLayertipe_legacy(state, action);
        case actionTypes.CHANGE_LAYERFILTER_LEGACY:
            return changeLayerFilter_legacy(state, action);
        case actionTypes.BIND_COMPONENT_LEGACY:
            return bindComponent_legacy(state, action);
        default:
            return state;
    }
};

export default reducer;